import type { BadgeTheme } from '../../Badge'
import type { LinkStyleText } from '../../Link/Link'
import { NavigationLink } from '../../Links/NavigationLink'
import { ProductLink } from '../../Links/ProductLink'

export const linkComponentMapper = {
  bestBuy: {
    badgeId: 'bestBuy',
    badgeTheme: 'best buy' as BadgeTheme,
    Component: ProductLink,
  },
  dontBuy: {
    badgeId: 'dontBuy',
    badgeTheme: 'dont buy' as BadgeTheme,
    Component: ProductLink,
  },
  standard: {
    textStyle: 'sb-text-interface-body-default-regular' as LinkStyleText,
    Component: NavigationLink,
  },
}
